import React from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';

export default function RefreshComp() {
    return (
        <RefreshIcon sx={{ color: 'var(--text-color)' }} />
    )
}